<template>
  <div class="photo-make-start-wrapper">
    <w-navbar :icon="'iconchevron-left'"
              nav_title="编辑照片"
              @mobileLeftBtn="leftBtnClick"
              v-if="!isRN && !cropperVisible"
              :isShowLeftIcon="true" />
    <div class="photo-make-content || originallyImg">
      <div class="photo-show-box">
        <img :src="photoObj.watermarked" alt="" class="photo-image">
        <span class="line top">150px</span>
        <span class="line right">210px</span>
        <span class="line bottom">25mm</span>
        <span class="line left">35mm</span>
      </div>
    </div>

    <div class="beauty-container">
      <div class="use-originally-img" @click="handleSourcePhoto" v-if="activeHeader === 1">
        <span class="iconfont iconicon_huifu" />
        <span>使用原图</span>
      </div>
      <div class="beauty-header">
        <div
          class="beauty-item"
          v-for="(item, index) in beautyHeader"
          :class="{'beauty-active': activeHeader === index}"
          @click="activeHeader = index">
          {{ item }}
        </div>
      </div>
      <div class="beauty-content">
        <Background :activeBg="activeBg" @submit="handleSubmitBg" v-if="activeHeader === 0" />
        <Fair
          :nowFair="nowFair"
          @fairChange="fairChange"
          v-show="activeHeader === 1" />
        <Clothes
          :tabDataClothes="tabDataClothes"
          :activeGender="activeGender"
          :nowClothesId="nowClothesId"
          @changeId="handleChangeCloth"
          @changeGender="changeGender"
          v-if="activeHeader === 2" />
      </div>
      <div class="beauty-footer">
        <div class="btn cropper-btn" @click="cropperVisible = true">
          重新裁剪
        </div>
        <div class="btn use-btn" @click="getNoWatermarkedPhotoFunc">
          使用到简历
        </div>
      </div>
    </div>

    <!-- 照片裁剪-->
    <vueCropper
      style="background: #000;position: fixed;top: 0;left: 0"
      ref="cropper"
      :img="option.img"
      :canMove="option.canMove"
      :autoCrop="option.autoCrop"
      :centerBox="option.centerBox"
      :fixed="option.fixed"
      v-if="cropperVisible"
      :fixedNumber="option.fixedNumber" />

    <div class="cropper-header-container" v-if="cropperVisible">
      <span class="iconfont iconx" @click="cancelCropper" />
      <span>裁剪照片</span>
      <span class="iconfont iconcheck" @click="submitCropper" />
    </div>

    <WLoading :show-text="true" v-show="loadingVisible" />
  </div>
</template>

<script>
import WNavbar from '@/components/global/w-navbar'
import WLoading from "@/components/global/w-loading"
import Background from './components/Background'
import Fair from './components/Fair'
import Clothes from './components/Clothes'

import { envMixin } from '@/assets/js/mixin/global'
import { componentsMixin } from '@/assets/js/mixin/components'
import {mapActions, mapMutations, mapState} from "vuex";
import {uuid} from "vue-uuid";
import {blobToFile, dataURLtoBlob} from "@/assets/js/utils";
const { VueCropper } = require('vue-cropper')
const oss = require('ali-oss')

const option = {
  img: '',
  canMove: true,
  autoCrop: true,
  centerBox: true,
  fixed: true,
  fixedNumber: [90, 126]
}

export default {
  data () {
    return {
      option,
      type: 'success', // 可能的值：1. success 通过 2. error 未通过
      imgFile: null, // 照片 base64
      imgType: null, // 照片类型
      photoId: null, // 唯一 id
      info: {}, // 照片质量检测的相关数据信息
      loadingVisible: false, // loading visible
      isRN: false,
      cropperVisible: true,
      originallyImg: null,
      beautyHeader: ['更改底色', '人像美颜', '正装样式'],
      activeHeader: 0,
      activeBg: 'white',
      tabDataClothes: { // 正装样式 可选数据
        boy_list: [],
        girl_list: []
      },
      resetFair: { //默认美颜
        skinsoft: 0, // 磨皮
        mouthlarge: 0, // 嘴巴
        skinwhite: 0, // 美白
        facelift: 0, // 瘦脸
        leyelarge: 0, // 左眼
        reyelarge: 0, // 右眼
        coseye: 0 // 亮眼
      },
      nowFair: { // 当前美颜
        skinsoft: 40, // 磨皮
        mouthlarge: 60, // 嘴巴
        skinwhite: 60, // 美白
        facelift: 60, // 瘦脸
        leyelarge: 60, // 左眼
        reyelarge: 60, // 右眼
        coseye: 60 // 亮眼
      },
      nowClothesId: -1, // 当前 正装 id
      photoObj: {
        origin: '',    // 无水印
        watermarked: ''     // 有水印
      },
      tempPhotoName: '',
      activeGender: 'boy_list',
      cvToken: '',
      userPhotoCount: 0,
      ossConfig: {
        region: 'oss-cn-beijing',
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        stsToken: ''
      },
      cv: {}
    }
  },
  mixins: [ envMixin, componentsMixin ],
  components: {
    WNavbar,
    VueCropper,
    WLoading,
    Background,
    Fair,
    Clothes
  },
  watch: {
    activeBg(val, oldVal) {
      this.editPhotoBeautyFunc()
    },
    nowClothesId(val, oldVal) {
      this.editPhotoBeautyFunc()
    },
  },
  computed: {
    ...mapState('cv', ['profiles', 'hasProfile']),
    ...mapState('user', ['userData' ]),
    // 是否是会员
    isMembership(){
      return this.userData?.is_membership
    },
  },
  async created () {
    this.isRN = !!window.ReactNativeWebView
    if(this.isRN){
      this.postMessage('pageMounted', 'pageMounted')
      this.initMessage()
    }
    const params = this.$db.ls.get('portraitParams') || '{}'
    // 获取相关数据
    const { imgFile, imgType, photoId, info, cvToken } = JSON.parse(params)
    this.imgFile = imgFile
    this.imgType = imgType
    this.photoId = photoId
    this.info = info
    // 确定类型
    this.type = info && info.status
    this.cvToken = cvToken
    console.log(this.$route.params, "===================>params")
    this.option = {
      ...this.option,
      img: imgFile
    }
    // 获取正装模板列表
    this.getPhotoTemplateFunc()
    // 获取证件照制作次数
    this.getUsePhotoCountFunc()
    // 获取 阿里云 oss 配置
    this.getOssConfig()
    // 获取简历详情
    await this.getCvDetail()
    // 获取到 profile
    this.getProfileData()
  },
  methods: {
    ...mapActions('cv', [ 'createProfileData', 'updateProfileData', 'createCvDetail', 'updateCvDetail', 'updateVipProfileData', 'updateVipCvDetail', 'getCvDetail', 'getProfileData' ]),
    ...mapMutations('cv', ['changeCvDetail']),
    // 最后更新头像 || 创建简历
    async uploadAvatar (file) {
      let { token, kind } = this.cv.basic_info
      let store = await oss(this.ossConfig)
      let avatar = `${ uuid.v4() }-avatar.png`
      let code = 2000

      let blob = dataURLtoBlob(file)
      let fileData = blobToFile(blob, avatar)

      try {
        let res = await store.put(`cv/profile/avatars/${ avatar }`, fileData)
        if (this.isRN) this.postMessage('test', res)
        if (res.res.statusCode !== 200) {
          this.showToast('上传失败')
          return
        }
        let { url } = res
        if (this.isRN) this.postMessage('test', {id: this.profiles, type: '22222', kind})
        // 简历模板 ===> 创建简历
        if (kind === 'template' || kind === 'sample') {
          try {
            let payload = JSON.parse(JSON.stringify(this.cv))
            payload.basic_info.source_cv_token = payload.basic_info.token
            payload.basic_info['sample_cv_source_token'] = payload.basic_info.token // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
            payload.basic_info.kind = null
            payload.basic_info.token = null
            let cvRes = await this.createCvDetail(payload)
            if (cvRes.code === 1000) {
              const { basic_info: { token: cvToken } } = cvRes.data
              token = cvToken
              code = await this.createProfileData({ token: cvToken, payload: { avatar_url: url }})
            }
          } catch (error) {
            console.log(error)
          }
          if (this.isRN) this.postMessage('test', {code, type: '33333', kind})
          // 创建 头像
        } else if (!this.profiles.id) {
          code = await this.createProfileData({ token, payload: { avatar_url: url } })
          if (this.isRN) this.postMessage('test', {code, type: '44444', kind})
          // 更新 头像
        } else if (this.profiles.id) {
          // this.updateProfileData({ token, payload: { avatar_url: url } })
          code = await this.updateVipProfileData({ token, payload: { avatar_url: url },  profile: {...this.profiles, avatar_url: url} })
          if (this.isRN) this.postMessage('test', {code, type: '55555', kind})
          if(code === 600213){
            this.showToast('该功能为会员专享', 1500)
            if (this.isRN) {
              this.postMessage('toMember', 'toMember')
            } else {
              this.$router.push(`/buy/member/order`)
            }
            return
          }
        }
        // 创建、更新头像成功
        if (code === 1000) {
          if (this.isRN) {
            setTimeout(() => {
              this.postMessage('makeSucceed', token)
            }, 2000)
          } else {
            setTimeout(() => {
              this.$router.replace(`/cvs/${ token }/editor`)
            }, 2000)
          }
        }
        // this.$emit('uploadSuccess', url)
      } catch (e) {
        console.log(e)
        if (this.isRN) this.postMessage('test', {k: e, l: 'cccc'})
      }
    },
    // 获取简历详情
    async getCvDetail() {
      try {
        let res = await this.$api.cv.getCvDetail(this.cvToken)
        console.log(res, "=================》resss")
        if (res.code === 1000) {
          this.cv = res.data
          this.changeCvDetail(this.cv)
        } else {
          this.showToast('未找到对应简历')
        }
      } catch (e) {

      }
    },
    // 初始化oss参数
    async getOssConfig () {
      let res = await this.$api.cv.getOssConfig({})
      if (res.code === 1000) {
        let { access_key_id, access_key_secret, expiration, request_id, security_token, bucket_name } = res.data
        this.ossConfig = {
          region: 'oss-cn-beijing',
          accessKeyId: access_key_id,
          accessKeySecret: access_key_secret,
          bucket: bucket_name,
          stsToken: security_token
        }
      }
    },
    // 获取可制作证件照次数
    async getUsePhotoCountFunc () {
      try {
        let res = await this.$api.portrait.getUsePhotoCount()
        if (res.code === 1000) {
          this.userPhotoCount = res.data.count
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 美颜
    fairChange(obj) {
      const { type, data } = obj
      this.nowFair = {
        ...this.nowFair,
        [type]: data
      }
      this.editPhotoBeautyFunc()
    },
    // 正装
    handleChangeCloth(id) {
      this.nowClothesId = id
    },
    // 正装性别
    changeGender(type) {
      this.activeGender = type
    },
    // 使用原图
    handleSourcePhoto() {
      this.nowFair = JSON.parse(JSON.stringify(this.resetFair))
      // 重新生成照片设置
      this.resetPhotoSetting()
    },
    // 重置图片设置
    async resetPhotoSetting(){
      let params = {
        file: this.originallyImg.split('base64,')[1],
        background_color: this.activeBg || null, // 背景色
        fair_level: this.formatFair(this.nowFair), // 美颜参数
        clothes: this.nowClothesId === -1 ? null : this.nowClothesId // 正装 id
      }
      // 照片美颜
      return await this.editPhotoBeautyFunc(params)
    },
    // 获取无水印证件照
    async getNoWatermarkedPhotoFunc () {
      this.loadingVisible = true
      if (!this.userPhotoCount) {
        this.loadingVisible = false
        this.showToast('证件照制作次数不足', 1500)
        setTimeout(() => {
          if (this.isRN) {
            this.postMessage('toMember', 'toMember')
          } else {
            this.$router.push(`/buy/member/order`)
          }
        }, 1500)
        return
      }
      if (this.isRN) this.postMessage('test', 'lalalal')
      try {
        let params = {
          file_name: this.tempPhotoName,
          clothes: this.nowClothesId === -1 ? null : this.nowClothesId
        }
        let res = await this.$api.portrait.getNoWatermarkedPhoto(params)
        if (res.code === 1000) {
          let fileImg = 'data:image/jpg;base64,' + res.data.img
          if (this.isRN) this.postMessage('test', fileImg)
          // this.noWatermarkedPhotoFile = 'data:image/jpg;base64,' + res.data.img
          // this.payDialogVisible = false
          // downloadjs(this.noWatermarkedPhotoFile, '超级简历证件照.png', "image/png")
          // this.setNotWatermarkImage(this.noWatermarkedPhotoFile)
          await this.uploadAvatar(fileImg)
        } else {
          this.showToast(res.msg || res.message)
        }
        this.loadingVisible = false
      } catch (error) {
        console.log(error)
        this.loadingVisible = false
      }
    },
    // 获取新的证件照
    async editPhotoBeautyFunc(options) {
      this.loadingVisible = true
      let params = options || {
        source_file: this.photoObj.origin, // 无水印的图片地址
        background_color: this.activeBg, // 背景色
        fair_level: this.formatFair(this.nowFair), // 美颜参数
        clothes: this.nowClothesId === -1 ? null : this.nowClothesId // 正装 id
      }
      if(!params.fair_level){
        delete params.fair_level
      }

      console.log(params, "===============>params")

      let res = await this.$api.portrait.editPhotoBeauty(params)
      if (res.code === 1000) {
        // 照片检测通过
        if (res.data.status === 'success') {
          // 存储 图片名 用于最后保存证件照时 获取无水印图片
          this.tempPhotoName = res.data.file_name
          // 保存图片
          this.photoObj = {
            origin: res.data.source_file, // 拿到无水印的照片
            watermarked: res.data.file_name_wm // 拿到有水印的照片
          }
          this.loadingVisible = false
          // 成功 toast
          this.showToast('修改成功')
          // 照片检测不通过
        } else if (res.data.status === 'error') {
          this.loadingVisible = false
          this.showToast('未通过照片检测')
        }
      } else {
        this.loadingVisible = false
        this.showToast(res.msg || res.message)
      }

    },
    // 值除以 100
    formatFair (val) {
      let obj = {}
      let isNull = true
      for(let prop in val) {
        // console.log(11111, val[prop])
        obj[prop] = val[prop] / 100
        if(obj[prop] !== 0){
          isNull = false
        }
      }
      if(isNull){
        obj = null
      }
      return obj
    },
    // 正装模板
    async getPhotoTemplateFunc() {
      try {
        let res = await this.$api.portrait.getPhotoTemplateData()
        if (res.code === 1000) {
          this.tabDataClothes = res.data
        } else {
          console.log(res.message)
        }
        console.log(this.tabDataClothes, "=============>lalal")
      } catch (error) {
        console.log(error)
      }
    },
    // 更改底色
    handleSubmitBg(obj) {
      this.activeBg = obj.en
    },
    // 取消裁剪
    cancelCropper() {
      this.cropperVisible = false
    },
    // 确定裁剪
    submitCropper() {
      this.$refs.cropper.getCropData(async file => {
        console.log(file, "===============>file")
        this.originallyImg = file
        this.imgFile = file
        await this.photoCheckFunc(file)
        await this.resetPhotoSetting()
        this.cropperVisible = false
      })
    },
    // initMessage
    initMessage() {
      window.receiveFile = msg => {
        // 拿到 base64 照片
        this.imgFile = msg
        // 照片质量检测
        this.photoCheckFunc(this.imgFile)
      }

      window.pageFocus = msg => {
        // 获取证件照制作次数
        this.getUsePhotoCountFunc()
        // 获取到 profile
        this.getProfileData()
      }
    },
    // postMessage
    postMessage(type, data) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type,
        data,
      }))
    },
    // 触发手机上传图片
    upImgTriggerFunc () {
      if (this.isRN) {
        this.postMessage('chooseFile', 'chooseFile')
      } else {
        this.$refs.upImgInput.click()
      }
    },
    // 监听图片
    upImgChangeFunc () {
      let file = this.$refs.upImgInput.files
      // 获取图片类型
      this.imgType = file[0].type.split('/')[1]
      // 处理新上传的图片文件 base64
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.onload = e => {
        // 拿到 base64 照片
        let imgFile = e.currentTarget.result
        // 照片质量检测
        this.photoCheckFunc(imgFile)
      }
    },
    // 上传图片到电脑
    async upImgComputerFunc () {
      if (this.type === 'error') return
      this.loadingVisible = true
      try {
        let params = {
          file_name: `${this.photoId}.${this.imgType}`,
          file_dir: 'cv/portrait/',
          file_data: this.imgFile.split('base64,')[1],
          photo_key: this.photoId
        }
        let res = await this.$api.transferStation.uploadPhoto('cv', params)
        if (res.code === 1000) {
          this.$router.push('/transfer-station/upload-portrait/success')
        } else {
          this.showToast(res.msg || res.message)
        }
        this.loadingVisible = false
      } catch (error) {
        console.log(error)
        this.loadingVisible = false
      }

    },
    // 照片质量检测
    async photoCheckFunc (val) {
      this.loadingVisible = true
      try {
        let params = {
          file: val.split('base64,')[1]
        }
        let res = await this.$api.transferStation.photoCheck(params)
        if (res.code === 1000) {
          this.imgFile = val
          this.type = res.data.status
          this.info = res.data
        } else if (res.code === 201203) {
          this.showToast('请求超时，请重新上传')
        } else {
          this.showToast(res.msg || res.message)
        }
        this.loadingVisible = false
      } catch (error) {
        console.log(error)
        this.loadingVisible = false
      }
    },
    leftBtnClick() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-make-start-wrapper {
  width: 100vw;
  height: 100vh;
  position: relative;
  .photo-make-content {
    width: 100%;
    //margin-top: 60px;
    padding-top: 60px;
    display: flex;
    justify-content: center;
    .photo-show-box {
      width: 230px;
      height: 274px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .photo-image {
        width: 150px;
        height: 210px;
        object-fit: cover;
      }
      .line {
        position: absolute;
        border-style: solid;
        border-color: #BCBCBC;

        font-size: 12px;
        font-weight: 400;
        color: #606060;
        line-height: 16px;
        text-align: center;

        &::before,
        &::after {
          content: "";
          position: absolute;
          width: 1px;
          height: 5px;
          background: #BCBCBC;
        }

        &.top {
          top: 3px;
          left: 50%;
          transform: translateX(-50%);
          width: 148px;
          border-bottom-width: 1px;
          padding-bottom: 4px;

          &::before {
            left: -1px;
            bottom: -3px;
          }

          &::after {
            right: -1px;
            bottom: -3px;
          }
        }

        &.right {
          right: -84px;
          top: 50%;
          transform: translateY(-50%) rotate(90deg);
          width: 208px;
          border-bottom-width: 1px;
          padding-bottom: 4px;

          &::before {
            left: -1px;
            bottom: -3px;
          }

          &::after {
            right: -1px;
            bottom: -3px;
          }
        }

        &.bottom {
          bottom: 3px;
          left: 50%;
          transform: translateX(-50%);
          width: 148px;
          border-top-width: 1px;
          padding-top: 4px;

          &::before {
            left: -1px;
            top: -3px;
          }

          &::after {
            right: -1px;
            top: -3px;
          }
        }

        &.left {
          left: -84px;
          top: 50%;
          transform: translateY(-50%) rotate(90deg);
          width: 208px;
          border-top-width: 1px;
          padding-top: 4px;

          &::before {
            left: -1px;
            top: -3px;
          }

          &::after {
            right: -1px;
            top: -3px;
          }
        }

      }
    }
  }
  .beauty-container {
    width: 100%;
    height: 286px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.07);
    position: fixed;
    left: 0;
    bottom: 0;
    .beauty-header {
      width: 100%;
      padding-top: 19px;
      display: flex;
      justify-content: center;
      align-items: center;
      .beauty-item {
        width: 25%;
        height: 100%;
        font-size: 15px;
        font-weight: 400;
        color: #9C9C9C;
        display: flex;
        justify-content: center;
        align-items: center;
        &.beauty-active {
          font-weight: 500;
          color: #679CFF;
        }
      }
    }
    .beauty-content {
      width: 100%;
      flex: 1;
      box-sizing: border-box;
      padding: 0 27px;
      display: flex;
      align-items: center;
    }
    .beauty-footer {
      width: 100%;
      height: 84px;
      box-sizing: border-box;
      padding: 0 27px;
      display: flex;
      gap: 12px;
      .btn {
        width: 50%;
        height: 48px;
        border-radius: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        &.cropper-btn {
          color: #679CFF;
          background-color: rgba(103, 156, 255, .06);
        }
        &.use-btn {
          color: #fff;
          background-color: #679CFF;
        }
      }
    }
    .use-originally-img {
      width: 93px;
      height: 32px;
      font-size: 13px;
      background: #FFFFFF;
      box-shadow: 0px -2px 10px 0px rgba(0,0,0,0.07);
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
      position: absolute;
      right: 16px;
      top: -44px;
      .iconfont {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .cropper-header-container {
    width: 100vw;
    color: #fff;
    padding: 10px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    //background: #fff;
    position: absolute;
    left: 0;
    top: 0;
    .iconfont {
      font-weight: 600;
      font-size: 20px;
    }
  }
}
</style>
